import styled, { keyframes } from "styled-components";
import colors from "../../../../styles/colors";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.tr`
  text-align: center;
  animation: ${fadeIn} 0.4s ease-out;

  td {
    padding: 40px 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const Message = styled.p`
  font-family: "Roboto", "Segoe UI", sans-serif;
  font-size: 1rem;
  color: ${colors.text.subtitle};
  margin: 0;
`;

export const Hint = styled.span`
  font-size: 0.85rem;
  color: ${colors.text.hint};
`;
